import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Tooltip } from '@qrios/frontend-library';
import { useContext, useMemo, memo, useState } from 'react';
import { ArrowBackIosNewOutlined, ArrowForwardIosOutlined } from '@mui/icons-material';

import { Icon } from '../../../../../common/icon';
import { RADIUS } from '../../../../../../styles/themes';

import { DrawerContext } from './drawerContext';

const useStyles = makeStyles((theme: Theme) => ({
  rowContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: theme.spacing(2, 0),
    width: '100%',
    color: theme.palette.primary.dark,
    '&:hover': {
      cursor: 'pointer',
      background: theme.pageLayout.drawer.navigation.menuItemHoverBgAlt
    }
  },
  switchContainer: {
    height: '40px',
    width: '16px',
    background: theme.palette.common.white,
    borderRadius: `${RADIUS.md}px 0 0 ${RADIUS.md}px`,
    justifyContent: 'center',
    display: 'flex',
    color: 'inherit',
    marginLeft: theme.spacing(2)
  },
  switch: {
    height: '40px',
    width: '16px',
    color: 'inherit'
  }
}));

const DrawerSwitch = () => {
  const { drawerState, toggleDrawerState } = useContext(DrawerContext);
  const [isTooltipOpen, setTooltipOpen] = useState<boolean>(false);
  const classes = useStyles();

  const icon = useMemo(() => (drawerState === 'open' ? ArrowBackIosNewOutlined : ArrowForwardIosOutlined), [
    drawerState
  ]);

  return (
    <Tooltip
      open={isTooltipOpen}
      disableHoverListener={true}
      disableInteractive={true}
      title="Toggle sidebar"
      placement="right"
    >
      <Box
        onClick={() => {
          toggleDrawerState();
          setTooltipOpen(false);
        }}
        onMouseEnter={() => {
          setTooltipOpen(true);
        }}
        onMouseLeave={() => {
          setTooltipOpen(false);
        }}
        className={classes.rowContainer}
      >
        <Box data-testid="collapse-sidebar-box" className={classes.switchContainer}>
          <Icon className={classes.switch} icon={icon} />
        </Box>
      </Box>
    </Tooltip>
  );
};

export default memo(DrawerSwitch);
